import { render, staticRenderFns } from "./playlist.vue?vue&type=template&id=2dc45c90&scoped=true&"
import script from "./playlist.vue?vue&type=script&lang=js&"
export * from "./playlist.vue?vue&type=script&lang=js&"
import style0 from "./playlist.vue?vue&type=style&index=0&id=2dc45c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc45c90",
  null
  
)

export default component.exports